import { registerComponent } from "helpers";

registerComponent(
  "footer-accordion",
  class FooterAccordion extends HTMLElement {
    connectedCallback() {
      const title = this.querySelector(".accordion-title");
      title.addEventListener("click", this.toggleAccordion.bind(this));
    }

    toggleAccordion() {
      const title = this.querySelector(".accordion-title");
      title.classList.toggle("accordion-title--active");

      const items = this.querySelector("ul");
      items.classList.toggle("active");
    }
  },
);
